const NotFoundPage = () => (
    <div id="NotFound" className="max-w-5xl text-center mx-auto">      
        <h3 className="text-white">404: Page Not Found</h3>
    </div>
)

export default NotFoundPage;